import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "editable-toggle-block" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "block-content q-mt-md" }
const _hoisted_4 = { class: "button-row flex justify-end q-mt-md" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_new = _resolveComponent("toggle-new")!
  const _component_pen_icon = _resolveComponent("pen-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_tick_icon = _resolveComponent("tick-icon")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_expansion_item, {
      class: "block-container",
      ref: "expansionItem",
      group: "toggle",
      modelValue: _ctx.expanded,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expanded) = $event))
    }, {
      header: _withCtx(() => [
        _renderSlot(_ctx.$slots, "title", {
          title: _ctx.title,
          editState: _ctx.editState,
          switchProp: _ctx.switchProp
        }, () => [
          (!_ctx.hideToggle)
            ? (_openBlock(), _createBlock(_component_toggle_new, {
                key: 0,
                "model-value": _ctx.editState[_ctx.switchProp] ? true : false,
                "onUpdate:modelValue": _ctx.onToggle,
                label: _ctx.title,
                readonly: _ctx.readonly,
                dense: ""
              }, null, 8, ["model-value", "onUpdate:modelValue", "label", "readonly"]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString(_ctx.title), 1))
        ], true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ editState: _ctx.editState, editingRef: _ctx.editingRef })), undefined, true),
          (!_ctx.readonly)
            ? _renderSlot(_ctx.$slots, "actions", _normalizeProps(_mergeProps({ key: 0 }, { editState: _ctx.editState, editingRef: _ctx.editingRef, cancel: _ctx.cancel, save: _ctx.save })), () => [
                _createElementVNode("div", _hoisted_4, [
                  (!_ctx.editingRef.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_q_btn, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editingRef.value = true)),
                          outline: "",
                          rounded: "",
                          unelevated: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_pen_icon, { left: "" }),
                            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Edit", -1))
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_q_btn, {
                          class: "q-mr-md",
                          onClick: _ctx.cancel,
                          rounded: "",
                          unelevated: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_close_icon, { left: "" }),
                            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Cancel", -1))
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_q_btn, {
                          onClick: _ctx.save,
                          color: "primary",
                          rounded: "",
                          unelevated: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_tick_icon, { left: "" }),
                            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Save", -1))
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                ])
              ], true)
            : _createCommentVNode("", true)
        ])
      ]),
      _: 3
    }, 8, ["modelValue"])
  ]))
}